import { getMovimientosCuentaAll } from "../services/serviceUsuarios";

const dataInicial = {
  array: [],
  exito: 0,
  nombre: "0",
  referencia: "0",
  fechaInicio: "",
  fechaFinal: ""
};

const GET_PAGOS_CLEAR_STATE = "GET_PAGOS_CLEAR_STATE";
const GET_PAGOS_ALL = "GET_PAGOS_ALL";

export default function pagosReducer(state = dataInicial, action) {
  switch (action.type) {
    case GET_PAGOS_ALL:
      return { ...state, array: action.payload.array, fechaInicio: action.payload.fechaInicio, fechaFinal: action.payload.fechaFinal };
    case GET_PAGOS_CLEAR_STATE:
      return {
        ...state,
        array: action.payload.array,
        exito: action.payload.exito,
      };
    default:
      return state;
  }
}

export const obtenerPagosAction = (fechaInicio, fechaFinal) => async (dispatch) =>{
  return await getMovimientosCuentaAll({fechaInicio, fechaFinal}).then((Response) =>{
    dispatch({
      type: GET_PAGOS_ALL,
      payload: {
        array: Response,
        fechaInicio,
        fechaFinal
      },
    });
  }).catch((Error) =>{
    return [];
  })
}

export const clearUsuarioState = () => async (dispatch) => {
  dispatch({
    type: GET_PAGOS_CLEAR_STATE,
    payload: dataInicial,
  });
};
